<template>
  <div class="mod_pic_list" v-if="ad">
    <div class="pic_list">
        <a class="item_link" :url="ad.url | urlNormalize" v-report="{f_bossId:5814,f_type:5,f_hottag:'ad.zengpian.h5',f_ptag:'ad.zengpian.h5'}">
            <img :src="ad.pic | urlNormalize">
        </a>
    </div>
  </div>

</template>

<script>

import { getAd } from '../service/ad'
import util from '@tencent/vft-common/util'
export default {
  data () {
    return {
      ad: null
    }
  },
  async created () {
    try {
      let ad = await getAd()
      ad.url = util.setUrlParam('ptag', 'ad.zengpian', ad.url)
      this.ad = ad
    } catch (ex) {

    }
  }
}
</script>
